import React from "react";
import { useFirebase } from "../../database/FirebaseContext";

                        
function ProductBacklogTask({ task, sprintID, openEditSprintTask, openTaskDetails, colourBlindMode}) {
    const { addTaskToSB } = useFirebase();

    const addToSb = () => {
        const newSprintTask = {
            sprintID: sprintID,
            taskID: task.id,
            userID: 999,
            sprintLogTime: [],
            sprintTotalLogTime: 0,
            sprintCompletionDate: "1-1-2023 (To be Changed)",
        };
        addTaskToSB(newSprintTask);
    };

    const getPriorityBackgroundColor = (colourBlindMode, priority) => {
        if (colourBlindMode === true) {
            switch (priority) {
                case 1:
                    return "bg-[#A2E365]";
                case 2:
                    return "bg-[#F3F38B]";
                case 3:
                    return "bg-[#D27D23]";
                default:
                    return "bg-[#C96514]";
            }
        }
        else {
            switch (priority) {
                case 1:
                    return "bg-[#00FF19]";
                case 2:
                    return "bg-[#DDFF0A]";
                case 3:
                    return "bg-[#FA632D]";
                default:
                    return "bg-[#ff3528]";
            }
        }
      };
    const getSPBackgroundColor = (colourBlindMode) => {
        switch (colourBlindMode) {
            case true:
                return "bg-[#D1D9FA]"
            default:
                return "bg-[#b7e1f9]";
        }
    };

    const getPriorityValue = (priority) => {
        const mapPriority = {
            1: "Low",
            2: "Medium",
            3: "Important",
            4: "Urgent",
        };
        return mapPriority[priority];
    };

    return (
        <div className="relative bg-[#616675] w-[95%] h-auto flex-1 py-2 rounded-3xl mb-[30px]">
            {/* section container */}
            <div className="text-white justify-between text-2xl relative flex mt-3 mb-2 mx-[6%] px-[1vh]">
                <span>{task.taskName}</span>

                <div class="whitespace-nowrap text-2xl">
                    <i
                        className="fa-solid fa-plus text-white"
                        onClick={addToSb}
                    ></i>

                    <i
                        className="fa-solid fa-pen-to-square fa-base list-item-icon text-white ml-4"
                        onClick={() => openEditSprintTask(task)}
                    ></i>
                    <i className="fa-solid fa-trash-can fa-base list-item-icon text-white ml-4"></i>
                </div>
            </div>
            
            <div className="h-[20%]" onClick={() => openTaskDetails(task)}>
                <div className="grid grid-cols-2 gap-4 mt-3 mx-[1vw]">
                    <div
                        className={`${getPriorityBackgroundColor(colourBlindMode,
                            task.taskPriority
                        )} h-[100%] w-[100%] col-span-1 rounded-md flex items-center justify-center text-center text-xl text-black`}
                    >
                        {getPriorityValue(task.taskPriority)}
                    </div>
                    <div className={`${getSPBackgroundColor(colourBlindMode)} h-[100%] w-[100%] col-span-1 rounded-md flex items-center justify-center text-center text-xl text-black`}>
                        Story Point: {task.taskStoryPoint}
                    </div>
                </div>

                <div className="bg-[#3D3E44] h-[6vh] mt-[2vh] p-[0.5vh] rounded-xl flex text-[14px] text-white col-span-2 mx-[1vw] mb-[2vh]">
                    {Object.values(task.taskTag).join(" | ")}
                </div>
            </div>
        </div>
    );
}

export default ProductBacklogTask;
